import { render, staticRenderFns } from "./uz.vue?vue&type=template&id=36403141&scoped=true&"
import script from "./uz.vue?vue&type=script&lang=js&"
export * from "./uz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36403141",
  null
  
)

export default component.exports